<template>
  <v-container
    fluid>
    <v-row
      jusitfy=start
      align=center>
      <v-col
        cols=2
        sm=1>
        <v-avatar>
          <v-icon
            :x-large="$vuetify.breakpoint.mdAndUp"
            :large="$vuetify.breakpoint.smAndDown"
            >mdi-account</v-icon>
        </v-avatar>
      </v-col>
      <v-col
        cols=9
        sm=9
        class="balloon-left">
        <p>本格的なプログラミングが勉強できるので、<br>将来の可能性が広がりそう！</p>
      </v-col>
    </v-row>
    <v-row
      justify=end
      align=center>
      <v-col
        cols=9
        sm=9
        class="balloon-right">
        <p>送り迎えの必要がないのは本当に楽。<br>転勤族なので、引っ越しても同じ先生の授業を<br>受けられるのもメリットだと思う。</p>
      </v-col>
      <v-col
        cols=2
        sm=1>
        <v-avatar>
          <v-icon
            :x-large="$vuetify.breakpoint.mdAndUp"
            :large="$vuetify.breakpoint.smAndDown"
            >mdi-account</v-icon>
        </v-avatar>
      </v-col>
    </v-row>
    <v-row
      jusitfy=start
      align=center>
      <v-col
        cols=2
        sm=1>
        <v-avatar>
          <v-icon
            :x-large="$vuetify.breakpoint.mdAndUp"
            :large="$vuetify.breakpoint.smAndDown"
            >mdi-account</v-icon>
        </v-avatar>
      </v-col>
      <v-col
        cols=9
        sm=9
        class="balloon-left">
        <p>タイピングを含め、パソコンに強くなることができて良い。<br>自分の書いたプログラムをすぐ実行できて楽しそう。</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'VUsersVoices',
}
</script>

<style scoped>

.balloon-left {
  position: relative;
  display: inline-block;
  margin: 1.5rem 0 1.5rem 15px;
  padding: 7px 10px;
  min-width: 120px;
  max-width: 100%;
  color: #555;
  font-size: 16px;
  background: #FFF;
  border: solid 3px #555;
  box-sizing: border-box;
  border-radius: 10px;
}

.balloon-left:before {
  content: "";
  position: absolute;
  top: 50%;
  left: -24px;
  margin-top: -12px;
  border: 12px solid transparent;
  border-right: 12px solid #FFF;
  z-index: 2;
}

.balloon-left:after {
  content: "";
  position: absolute;
  top: 50%;
  left: -30px;
  margin-top: -14px;
  border: 14px solid transparent;
  border-right: 14px solid #555;
  z-index: 1;
}

.balloon-left p {
  margin: 0;
  padding: 0;
}

.balloon-right {
  position: relative;
  display: inline-block;
  margin: 1.5rem 15px 1.5rem 0;
  padding: 7px 10px;
  min-width: 120px;
  max-width: 100%;
  color: #555;
  font-size: 16px;
  background: #FFF;
  border: solid 3px #555;
  box-sizing: border-box;
  border-radius: 10px;
}

.balloon-right:before {
  content: "";
  position: absolute;
  top: 50%;
  right: -24px;
  margin-top: -12px;
  border: 12px solid transparent;
  border-left: 12px solid #FFF;
  z-index: 2;
}

.balloon-right:after {
  content: "";
  position: absolute;
  top: 50%;
  right: -30px;
  margin-top: -14px;
  border: 14px solid transparent;
  border-left: 14px solid #555;
  z-index: 1;
}

.balloon-right p {
  margin: 0;
  padding: 0;
}

</style>
